export type ExpenseCategory = "SALARY" | "COMMISSION" | "INSURANCE" | "OFFICE" | "SERVER" | "BNS" | "BONUS" | "OTHER";
export type ExpenseType = "MONTHLY" | "YEARLY" | "IRREGULAR";
export type ExpenseStatus = "PENDING_CONFIRM" | "PENDING_PAYMENT" | "PAID";

export const expenseCategoryOptions: { value: ExpenseCategory; label: string }[] = [
  { value: "SALARY", label: "Lương" },
  { value: "COMMISSION", label: "Hoa hồng" },
  { value: "INSURANCE", label: "Bảo hiểm" },
  { value: "OFFICE", label: "Văn phòng" },
  { value: "SERVER", label: "Server / SSL / Google / AI" },
  { value: "BNS", label: "BNS" },
  { value: "BONUS", label: "Thưởng" },
  { value: "OTHER", label: "Khác" },
];

export const expenseTypeOptions: { value: ExpenseType; label: string }[] = [
  { value: "MONTHLY", label: "Hàng tháng" },
  { value: "YEARLY", label: "Hàng năm" },
  { value: "IRREGULAR", label: "Không cố định" },
];

export const expenseStatusTrans: Record<ExpenseStatus, { label: string; color: string; bgcolor: string }> = {
  PENDING_CONFIRM: { label: "Chờ xác nhận", color: "#b54708", bgcolor: "#fffaeb" },
  PENDING_PAYMENT: { label: "Chờ thanh toán", color: "#175cd3", bgcolor: "#eff8ff" },
  PAID: { label: "Đã thanh toán", color: "#027a48", bgcolor: "#d1fadf" },
};

export const expenseStatusOptions = (Object.keys(expenseStatusTrans) as ExpenseStatus[]).map((value) => ({
  value,
  label: expenseStatusTrans[value].label,
}));

export const expenseCategoryLabel = (category: ExpenseCategory) =>
  expenseCategoryOptions.find((option) => option.value === category)?.label || category;

export const expenseTypeLabel = (type: ExpenseType) =>
  expenseTypeOptions.find((option) => option.value === type)?.label || type;

export interface Expense {
  id: number;
  code: string;
  category: ExpenseCategory;
  name: string;
  amount: number;
  type: ExpenseType;
  expenseDate: string;
  status: ExpenseStatus;
}

export interface ExpenseSummary {
  from: string;
  to: string;
  expenseCount: number;
  actualExpense: number;
}

export interface ExpenseMonthlyPoint {
  month: number;
  expense: number;
}

export interface ExpenseCategoryPoint {
  category: ExpenseCategory;
  expense: number;
}

export interface ProfitMonthlyPoint {
  month: number;
  revenue: number;
  expense: number;
  profit: number;
}
